import React, { useContext } from "react";
import { observer } from "mobx-react";
import { AppWorkspaceContext } from "../stores/AppWorkspace";
import { Panel } from "../../ui";

const fmtDate = (iso: string | null | undefined) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return iso;
  }
};

const AccountInfoCard: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext);
  const account = workspace.account?.data;
  if (!account) return null;

  return (
    <Panel>
      <div className="mb-3 text-lg font-semibold">Account</div>
      <div className="flex flex-col gap-2 text-sm">
        <div className="flex justify-between gap-4">
          <span className="text-muted">Email</span>
          <span>{account.email}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-muted">Member since</span>
          <span>{fmtDate(account.created_at)}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-muted">Account ID</span>
          <span className="font-mono">{account.uuid}</span>
        </div>
      </div>
    </Panel>
  );
});

export default AccountInfoCard;
